import { createTheme } from "@mui/material/styles";

declare module "@mui/material/styles/createPalette" {
	interface Palette {
		tertiary: Palette["primary"];
		signalRed: Palette["primary"];
		oceanGrey: {
			50: string;
			100: string;
			200: string;
			300: string;
			400: string;
			500: string;
			600: string;
			700: string;
			800: string;
			900: string;
		};
		oceanBlue: {
			50: string;
			100: string;
			200: string;
			300: string;
			400: string;
			500: string;
			600: string;
			700: string;
			800: string;
			900: string;
		};
	}
	interface PaletteOptions {
		tertiary: Palette["primary"];
		signalRed: Palette["primary"];

		oceanGrey: {
			50: string;
			100: string;
			200: string;
			300: string;
			400: string;
			500: string;
			600: string;
			700: string;
			800: string;
			900: string;
		};
		oceanBlue: {
			50: string;
			100: string;
			200: string;
			300: string;
			400: string;
			500: string;
			600: string;
			700: string;
			800: string;
			900: string;
		};
	}
}

export const BACKGROUND_COLOR = "#EBEDEF";

let theme = createTheme({
	palette: {
		primary: {
			main: "#34495E",
			dark: "#212F3C",
		},
		secondary: {
			main: "#1A5276",
		},
		tertiary: {
			main: "#5D6D7E",
			light: "#AEB6BF",
			dark: "#34495E",
			contrastText: "#FFF",
		},
		signalRed: {
			main: "#FF330F",
			light: "#FF5E4C",
			dark: "#CC0000",
			contrastText: "#FFF",
		},
		oceanGrey: {
			50: "#EBEDEF",
			100: "#D6DBDF",
			200: "#AEB6BF",
			300: "#85929E",
			400: "#5D6D7E",
			500: "#34495E",
			600: "#2E4053",
			700: "#283747",
			800: "#212F3C",
			900: "#1B2631",
		},
		oceanBlue: {
			50: "#EAF2F8",
			100: "#D4E6F1",
			200: "#A9CCE3",
			300: "#7FB3D5",
			400: "#5499C7",
			500: "#2980B9",
			600: "#2471A3",
			700: "#1F618D",
			800: "#1A5276",
			900: "#154360",
		},
	},
	typography: {
		fontFamily: "Avenir, sans-serif",
		fontWeightRegular: 400,
		h5: {
			fontWeight: 500,
			fontSize: 26,
			letterSpacing: 0.5,
		},
	},
	shape: {
		borderRadius: 8,
	},
	components: {
		MuiTab: {
			defaultProps: {
				disableRipple: true,
			},
		},
	},
	mixins: {
		toolbar: {
			minHeight: 48,
		},
	},
});

theme = {
	...theme,
	components: {
		MuiDrawer: {
			styleOverrides: {
				paper: {
					backgroundColor: theme.palette.primary.dark,
				},
			},
		},
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: "none",
				},
				contained: {
					boxShadow: "none",
					"&:active": {
						boxShadow: "none",
					},
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					marginLeft: theme.spacing(1),
				},
				indicator: {
					height: 3,
					borderTopLeftRadius: 3,
					borderTopRightRadius: 3,
					backgroundColor: theme.palette.signalRed.main,
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					textTransform: "none",
					margin: "0 16px",
					minWidth: 0,
					padding: 0,
					[theme.breakpoints.up("md")]: {
						padding: 0,
						minWidth: 0,
					},
					opacity: 1,
				},
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: {
					padding: theme.spacing(1),
				},
			},
		},
		MuiTooltip: {
			styleOverrides: {
				tooltip: {
					borderRadius: 4,
				},
			},
		},
		MuiDivider: {
			styleOverrides: {
				root: {
					backgroundColor: "rgb(255,255,255,0.15)",
				},
			},
		},
		MuiListItemButton: {
			styleOverrides: {
				root: {
					"&.Mui-selected": {
						color: theme.palette.common.white,
					},
				},
			},
		},
		MuiListItemText: {
			styleOverrides: {
				primary: {
					fontSize: 14,
					fontWeight: theme.typography.fontWeightMedium,
				},
			},
		},
		MuiListItemIcon: {
			styleOverrides: {
				root: {
					color: "inherit",
					minWidth: "auto",
					marginRight: theme.spacing(2),
					"& svg": {
						fontSize: 20,
					},
				},
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					width: 32,
					height: 32,
				},
			},
		},
	},
};

export default theme;
